import { render, staticRenderFns } from "./CommonBaseDate.vue?vue&type=template&id=040d415c&scoped=true"
import script from "./CommonBaseDate.vue?vue&type=script&lang=js"
export * from "./CommonBaseDate.vue?vue&type=script&lang=js"
import style0 from "./CommonBaseDate.vue?vue&type=style&index=0&id=040d415c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040d415c",
  null
  
)

export default component.exports